import React, { useState, useEffect } from 'react';
import { Tab, Nav, Col, Row, Card, Form, Button, Spinner } from 'react-bootstrap';
import RenderizarProduto from '../components/Utils/RenderizarProduto';
import BotaoFlutuante from '../components/Button/BotaoFlutuante';
import Swal from 'sweetalert2';
import { useProvider, Toast } from "../context/MenuProvider";
import { Link, useParams } from 'react-router-dom';

const Templates = ({tipo}) => {
    const [query, setQuery] = useState(''); // Termo de pesquisa
    const [templates, setTemplates] = useState([]); // Cobrancas carregados
    const [nextUrl, setNextUrl] = useState(null); // URL da próxima página
    
    const { 
      setLinks, 
      setBtns,
      crud,
      hasPerms,
      hasPermsAnd,
      navigateTo,
      setTitle
    } = useProvider();
    const { get, post, del, loading } = crud || {};  // Obtendo os métodos do hook useCrud
    
    // Função para buscar templates na API
    const buscarTemplates = async (url = `/core/templates/?expand=categoria&tipo=${tipo}&ordering=horario`) => {
        if (query) url += `&search=${query}`;
        
        if (!url) return; // Evita chamada se já estiver loading ou sem URL válida
        try{
          const response = await get(url, tipo);
          if(response && response.length){
            const novosItens = response[0].results; // Corrigir para acessar o resultado correto
            setTemplates((itensAnteriores) => !nextUrl ? novosItens : [...itensAnteriores, ...novosItens]);
            setNextUrl(response[0].next);
          }
          
        }catch(err){
          // Toast.fire({
          //     icon: "error",
          //     title: "Falha ao buscar templates"
          // });
        }finally{
          
        }
    };

    // Carrega os templates ao montar o componente ou aplicar um novo filtro
    useEffect(() => {
      buscarTemplates(); // Sempre faz uma nova busca
    }, [query, tipo]);
    
    useEffect(() => {
      setLinks([
       // { name: 'Configurar estoque (Casal)', to: '/estoque/sincronizar' },
       // { name: 'Sincronizar templates', to: '/estoque/sincronizar' },
      ]);
      setBtns([]);
      return () => {setLinks([]); setBtns([]);}
    }, [setLinks, setBtns]);
    
    const templatePadraoCobranca = () => {
      Swal.fire({
        title: "Criar Template Padrão",
        text: "Você está prestes a criar um template padrão cobranças.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Sim, Criar!",
        cancelButtonText: "Cancelar"
      }).then(async(result) => {
        if (result.isConfirmed) {
          try{
            const response = await post({}, `/core/templates/padrao-cobranca/`);
            
            Toast.fire({
                icon: "success",
                title: 'Template criado com sucesso'
            });
            navigateTo(`/config/templates/editar/${response[0].id}/`)
          }catch(err){
            
          }
        }
      });
    }
    
    const templatePadraoPosVenda = () => {
      Swal.fire({
        title: "Criar Template Padrão",
        text: "Você está prestes a criar um template pós-venda.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Sim, Criar!",
        cancelButtonText: "Cancelar"
      }).then(async(result) => {
        if (result.isConfirmed) {
          try{
            const response = await post({}, `/core/templates/padrao-pos-venda/`);
            
            Toast.fire({
                icon: "success",
                title: 'Template criado com sucesso'
            });
            navigateTo(`/config/templates/editar/${response[0].id}/`)
          }catch(err){
            
          }
        }
      });
    }
    
    const templatePadraoReativarCliente = () => {
      Swal.fire({
        title: "Criar Template Padrão",
        text: "Você está prestes a criar um template reativar cliente.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Sim, Criar!",
        cancelButtonText: "Cancelar"
      }).then(async(result) => {
        if (result.isConfirmed) {
          try{
            const response = await post({}, `/core/templates/padrao-reativar-cliente/`);
            
            Toast.fire({
                icon: "success",
                title: 'Template criado com sucesso'
            });
            navigateTo(`/config/templates/editar/${response[0].id}/`)
          }catch(err){
            
          }
        }
      });
    }

    // Detecta o fim da página para carregar mais templates
    useEffect(() => {
        const handleScroll = () => {
            if (window.innerHeight + document.documentElement.scrollTop >= document.documentElement.offsetHeight - 100) {
                if (!loading && nextUrl) buscarTemplates(nextUrl);
            }
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, [loading, nextUrl]);
    
    const excluirTemplate = (id) => {
      Swal.fire({
        title: "Tem certeza em excluir?",
        text: "Esta ação é definitiva e todos os clientes não receberão mais mensagens com esse template, não poderá ser revertida.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Sim, excluir!",
        cancelButtonText: "Cancelar"
      }).then(async(result) => {
        if (result.isConfirmed) {
          try{
            const response = await del(`/core/templates/${id}/`);
            setTemplates((prev)=>prev.filter(x=>x.id!=id))
            Toast.fire({
                icon: "success",
                title: 'Template excluída com sucesso'
            });
          }catch(err){
            
          }
        }
      });
    }
    
    return (
        <>
            <BotaoFlutuante to={`/config/templates/novo/${tipo}`} icon="bi-plus"></BotaoFlutuante>
            <div className="mt-2">
                <Form>
                      <Form.Group controlId="formCobranca" className="mb-3">
                        <div className="input-group">
                          {tipo==='cobranca' && <Button variant="outline-dark" onClick={templatePadraoCobranca}><i className="bx bx-timer"></i> Padrão</Button>}
                          {tipo==='pos-venda' && <Button variant="outline-dark" onClick={templatePadraoPosVenda}><i className="bx bx-timer"></i> Padrão</Button>}
                          {tipo==='reativar-cliente' && <Button variant="outline-dark" onClick={templatePadraoReativarCliente}><i className="bx bx-timer"></i> Padrão</Button>}
                          <Form.Control 
                              type="text" 
                              placeholder="Pesquisa..." 
                              value={query} 
                              onChange={(e) => setQuery(e.target.value)} 
                          />
                          <Button variant="secondary" onClick={() => buscarTemplates()}>
                              <i className="bi bi-search"></i>
                          </Button>
                        </div>
                      </Form.Group>
                </Form>
                
                <div className="list-group mt-3">
                    {templates.length > 0 ? (
                      templates.map((x) => (<>
                        <Row>
                          <Col></Col>
                          <Col xs="auto" className="border-top mt-2 pt-1 mb-1">
                            <b>Com {x.usando} cliente{x.usando>1?'s':''}</b>
                            <Button variant="secondary" size="sm" className="ms-2" onClick={()=>navigateTo(`/config/templates/editar/${x.id}/`)}><i className="bx bx-edit"></i></Button>
                            <Button variant="danger" size="sm" className="ms-2" onClick={()=>excluirTemplate(x.id)}><i className="bx bx-trash"></i></Button>
                          </Col>
                        </Row>
                        <RenderizarProduto
                          key={x.id}
                          lm="mb-1"
                          col="d-none"
                          to={`/config/templates/${x.id}`}
                          text1={`${x.categoria?.nome ||''}`}
                          titulo={`${x.horario} ${x.titulo || ''}`}
                          markdown={x.mensagem}//${x.mensagem}`}
                        />
                      </>
                      ))
                    ) : (
                      !loading && <p className="text-center text-muted">Nenhum template encontrado.</p>
                    )}
                    {loading && <p className="text-center"><Spinner animation="border" /></p>}
                    {nextUrl && !loading && (
                        <Button variant="secondary" onClick={() => buscarTemplates(nextUrl)} className="mt-2  text-center">
                            Buscar mais...
                        </Button>
                    )}
                </div>
            </div>
        </>
    );
}

const TemplateList = () => {
    const { tipo } = useParams(); 
    const [formType, setFormType] = useState(tipo??"cobranca");
    const { 
      setLinks, 
      setBtns,
      crud,
      hasPerms,
      hasPermsAnd,
      navigateTo,
      setTitle,
    } = useProvider();
    useEffect(()=>{
      if(tipo !== formType){
        navigateTo(`/config/templates/${formType}`, {replace:true})
      }
      switch(formType){
        case "cobranca":
          setTitle("Template de Cobranças");
          break;
        case "pos-venda":
          setTitle("Template de Pós Venda");
          break;
        case "reativar-cliente":
          setTitle("Template de Reativar Clientes");
          break;
        case "novidades":
          setTitle("Template de Novidades");
          break;
      }
    },[formType])
  
    // Monta os itens com base nas permissões
    const navItems = [
      hasPermsAnd([
        "core.view_template",
        "loja.view_venda",
        "loja.view_pagamento",
      ]) && {
        key: "cobranca",
        icon: "bx bx-dollar",
        label: "Cobranças",
        component: <Templates tipo="cobranca"/>
      },
      hasPermsAnd([
        "core.view_template",
        "loja.view_venda",
      ]) && {
        key: "pos-venda",
        icon: "bx bx-basket",
        label: "Pós Venda",
        component: <Templates tipo="pos-venda"/>
      },
      hasPermsAnd([
        "core.view_template",
        "loja.view_venda",
        "loja.view_clientes",
      ]) && {
        key: "reativar-cliente",
        icon: "bx bx-group",
        label: "Reativar Clientes",
        component: <Templates tipo="reativar-cliente"/>
      },
      hasPermsAnd([
        "core.view_template",
        "loja.view_clientes",
      ]) && {
        key: "novidades",
        icon: "bx bx-bulb",
        label: "Novidades",
        component: <Templates tipo="novidades"/>
      },
    ].filter(Boolean); // remove os falsos
    
    useEffect(()=>{
      if (!tipo && navItems?.length){
        setFormType(navItems[0].key);
      }
    },[navItems])
    
    return (
      <>
        <Tab.Container id="details-tabs" activeKey={formType} onSelect={(k) => setFormType(k)}>
          
          {/* Só renderiza se houver mais de 1 item */}
          {navItems.length > 1 && (
            <Nav variant="tabs" className="justify-content-center d-flex flex-nowrap overflow-auto">
              {navItems.map(item => (
                <Nav.Item key={item.key}>
                  <Nav.Link eventKey={item.key} className="text-center">
                    <i className={`${item.icon} fs-1 text-dark`}></i>
                    <div className="small text-muted">{item.label}</div>
                  </Nav.Link>
                </Nav.Item>
              ))}
            </Nav>
          )}
  
          <Tab.Content>
            {navItems.map(item => (
              <Tab.Pane key={item.key} eventKey={item.key}>
                {item.component}
              </Tab.Pane>
            ))}
          </Tab.Content>
        </Tab.Container>
      </>
    );
};

export default TemplateList;